"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Box_1 = __importDefault(require("@mui/material/Box"));
var NeutralDivider_1 = __importDefault(require("atomicComponents/atoms/Divider/NeutralDivider"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var IconCardWrapper_1 = __importDefault(require("./IconCardWrapper"));
var BorderlessCard = function (_a) {
    var title = _a.title, heading = _a.heading, description = _a.description, byline = _a.byline, icon = _a.icon, rest = __rest(_a, ["title", "heading", "description", "byline", "icon"]);
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ position: "relative", pb: { xs: 4, md: 0 } }, rest, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, color: "neutral.dark", fontWeight: "600", lineHeight: "32px", sx: { textTransform: 'uppercase' } }, { children: title })), (0, jsx_runtime_1.jsx)(NeutralDivider_1.default, {}), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2, lineHeight: "40px", mt: 0.5 }, { children: heading })), byline && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", color: "riverstone" }, { children: byline })), description && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", lineHeight: "20px" }, { children: description })), icon && (0, jsx_runtime_1.jsx)(IconCardWrapper_1.default, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "lg" }) })] })));
};
exports.default = BorderlessCard;
